var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.videoUrl)?_c('video',{staticClass:"hide-progress-bar",attrs:{"id":"myVideo","src":_vm.videoUrl,"autoplay":""},on:{"ended":() => _vm.changeFile('1', true)}}):_c('div',[_vm._v("暂无视频播放")])])
}
var staticRenderFns = []

export { render, staticRenderFns }